module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_live_retouch-9defffe5b2b276a0eefafd56185221b2.jpg";